// extracted by mini-css-extract-plugin
export default {"Portfolio":"Portfolio_Portfolio__LiU+a","CarouselContainer":"Portfolio_CarouselContainer__5ssRH","Button":"Portfolio_Button__xJKwO"};